import api from '../../plugins/api';

const getClientDocuments = (params) => {
  return api.get('/api/crm/clients/getClientDocuments', params);
};

export default getClientDocuments;
